import React from 'react'
import PropTypes from 'prop-types'
import ActionsMenu from '../../ui/ActionsMenu'
import CopyIcon from '../../ui/icons/CopyIcon'
import PenIcon from '../../ui/icons/PenIcon'
import TrashIcon from '../../ui/icons/TrashIcon'

const ConfiguredAlertActionsMenu = ({
  anchorEl = null, isOpen, onClose, onDuplicate, onEdit, onDelete
}) => {
  const items = [
    { label: 'Dupliquer', icon: CopyIcon, onClick: onDuplicate },
    { label: 'Modifier', icon: PenIcon, onClick: onEdit },
    { label: 'Supprimer', icon: TrashIcon, onClick: onDelete, variant: 'danger', dividerBefore: true }
  ]
  return (
    <ActionsMenu
      anchorEl={anchorEl}
      ariaLabel="Actions sur l’alerte configurée"
      isOpen={isOpen}
      items={items}
      onClose={onClose}
    />
  )
}

ConfiguredAlertActionsMenu.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
}

ConfiguredAlertActionsMenu.defaultProps = {
  anchorEl: null
}

export default ConfiguredAlertActionsMenu
